module.exports = __webpack_public_path__ + "static/media/loginRegisterBackgroundImage.0dfe5265.png";